export const getDocomsTrans = (arr:any, lang:string) => {
    if(!Array.isArray(arr)) return '';

    let result:string = '';
    
    switch (lang) {
        case 'N':
            result = arr?.find((i:any) => i?.nationid?.toString() === '12')?.oms
            break;
        case 'F':
            result = arr?.find((i:any) => i?.nationid?.toString() === '5')?.oms
            break;
        case 'E':
            result = arr?.find((i:any) => i?.nationid?.toString() === '3')?.oms
            break;
        default:
            result = arr?.find((i:any) => i?.nationid?.toString() !== '')?.oms
            break;
    }

    return result;
}